"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDataProvider = exports.createDataProviderWithOptions = void 0;
exports.prepareTrackingFilters = prepareTrackingFilters;
exports.prepareTrackingQueryOptions = prepareTrackingQueryOptions;
exports.getResultsForQueryOptions = getResultsForQueryOptions;
exports.createDataUpdateProvider = createDataUpdateProvider;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var DataProviderDecorators_1 = require("icf-search-client-data/lib/DataProviderDecorators");
var SearchFilters_1 = require("icf-search-client-data/lib/SearchFilters");
var Utilities_1 = require("icf-search-client-data/lib/Utilities");
var pick_1 = __importDefault(require("lodash/fp/pick"));
/**
 * @return A string encoded in the V3 format (ex: gender:f;ethnicity:Asian)
 */
function prepareTrackingFilters(filters) {
    return (0, SearchFilters_1.getFilterArray)(filters)
        .map(function (filter) { return "".concat(filter.name, ":").concat(filter.value); })
        .join(";");
}
function prepareTrackingQueryOptions(rawQueryOptions) {
    // We are explicitly selecting the query options properties here to include in tracking events
    var options = (0, pick_1.default)(["category", "gender", "isNotFound", "keyword", "performerId", "type"], rawQueryOptions);
    var filtersValue = prepareTrackingFilters(rawQueryOptions.filters);
    if (filtersValue !== "") {
        // TODO: wtf, is it the encoded string or the filters object?
        // @ts-ignore
        options.filters = filtersValue;
    }
    return options;
}
function getResultsForQueryOptions(client, pageRequestOptions, options) {
    if (options.staticPerformerIds) {
        return client.getPerformersByIds(__assign(__assign({}, pageRequestOptions), { performerIds: options.staticPerformerIds, preserveOrder: true }));
    }
    switch (options.type) {
        case "keyword":
            return client.getKeywordSearch(__assign(__assign({}, pageRequestOptions), { keyword: options.keyword, filters: options.filters }));
        case "category":
            return client.getPerformersInCategory(__assign(__assign(__assign({}, pageRequestOptions), { categoryName: options.category }), (0, pick_1.default)(["filters", "country", "language"], options)));
        case "favorites":
            return client.getFavoritePerformers(__assign(__assign({}, pageRequestOptions), { filters: options.filters }));
        case "tag":
        // tag search is just browse with a tag filter set
        // We use the tag type to differentiate the header
        // IMPORTANT: make sure this case flows into browse
        case "browse":
            return client.getPerformerList(__assign(__assign(__assign({}, pageRequestOptions), (0, pick_1.default)(["filters", "excludedFilters", "country", "language", "notExactBoostedFilters"], options)), { genderSetting: options.genderSetting ? options.genderSetting : "", includeFavorites: options.includeFavorites }));
        case "contest":
            return client.getPerformersInContest(__assign(__assign({}, pageRequestOptions), { filters: options.filters, contestFilter: options.contestFilter, contestId: options.contestInfo.contestId, genderSetting: "" }));
        default:
            throw new Error("Provided search data props do not specify a valid search type.");
    }
}
var createDataProviderWithOptions = function (dataPropsProviderFunc, clientFactoryFunc, removalExclusionIdsProviderFunc, logger, geoIds, dataReceivedCallback) {
    var dataProps = dataPropsProviderFunc();
    var client = clientFactoryFunc();
    var dataProvider = function (pageRequestOptions) {
        return getResultsForQueryOptions(client, pageRequestOptions, __assign(__assign({}, dataProps.queryOptions), { genderSetting: dataProps.genderSetting, includeFavorites: dataProps.includeFavorites })).then(function (pageResults) {
            var filtered = pageResults.results.filter(function (performer) { return !isBlocked(performer, geoIds); });
            return __assign(__assign({}, pageResults), { results: filtered });
        });
    };
    dataProvider = (0, DataProviderDecorators_1.withRetries)(dataProvider, [3000, 6000]);
    if (dataProps.shuffled) {
        dataProvider = (0, DataProviderDecorators_1.withShuffledData)(dataProvider);
    }
    if (dataProps.queryOptions.type !== "contest") {
        dataProvider = (0, DataProviderDecorators_1.withRemovalExclusion)(dataProvider, removalExclusionIdsProviderFunc(), Utilities_1.getPerformerId);
        dataProvider = (0, DataProviderDecorators_1.withMissingItemReplacement)(dataProvider, Utilities_1.getPerformerId, client.getFreeAccountTileXment());
    }
    if (dataProps.fallbackData) {
        dataProvider = (0, DataProviderDecorators_1.withFallbackData)(dataProvider, (0, exports.createDataProviderWithOptions)(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- based on above check
        function () { return dataProps.fallbackData; }, clientFactoryFunc, removalExclusionIdsProviderFunc, logger, geoIds, dataReceivedCallback));
    }
    if (dataProps.asDirectFallback) {
        dataProvider = (0, DataProviderDecorators_1.asFallback)(dataProvider);
    }
    if (dataReceivedCallback) {
        dataProvider = (0, DataProviderDecorators_1.withResultsCallback)(dataProvider, dataReceivedCallback, logger);
    }
    return dataProvider;
};
exports.createDataProviderWithOptions = createDataProviderWithOptions;
var createDataProvider = function (dataPropsProviderFunc, clientProviderFunc, removalExclusionIdsProviderFunc, logger, geoIds, resultsRecievedCallback) {
    return function (pageRequestOptions, previousResults) {
        return (0, exports.createDataProviderWithOptions)(dataPropsProviderFunc, clientProviderFunc, removalExclusionIdsProviderFunc, logger, geoIds, resultsRecievedCallback)(pageRequestOptions, previousResults);
    };
};
exports.createDataProvider = createDataProvider;
var performerEqualityComparer = function (a, b) {
    return !a.hasDetails || !b.hasDetails ? false : a.id === b.id;
};
function createDataUpdateProvider(clientFactoryFunc) {
    var _this = this;
    var getUpdatedData = function (performerData) { return __awaiter(_this, void 0, void 0, function () {
        var client, result, _e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!performerData.hasDetails) {
                        return [2 /*return*/, null];
                    }
                    client = clientFactoryFunc();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.getPerformersByIds({
                            pageIndex: 0,
                            pageSize: 1,
                            performerIds: [performerData.id],
                        })];
                case 2:
                    result = _a.sent();
                    if (result.results.length > 0) {
                        // The performer data is merged because status updates only have a subset
                        // of the data we get from Elasticsearch.
                        return [2 /*return*/, __assign(__assign({}, performerData), result.results[0])];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _e_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, null];
            }
        });
    }); };
    return {
        get getUpdatedData() {
            return getUpdatedData;
        },
        get equalityComparer() {
            return performerEqualityComparer;
        },
    };
}
var isBlocked = function (performer, geoIds) {
    if (performer.hasDetails && performer.blockedLocations) {
        if (geoIds.length < 1)
            return performer.blockedLocations.length > 0;
        return performer.blockedLocations.some(function (id) { return geoIds.includes(id); });
    }
    return false;
};
//# sourceMappingURL=PerformerDataSourceContextProps.js.map